<script>
import BillingEventComboBox from './BillingEventComboBox'
import TargetingComboBox from './TargetingComboBox'
import BudgetForm from './BudgetForm'
import ValueComboBox from './ValueComboBox'
import RelativeDateComboBox from './RelativeDateComboBox'

export default {
  name: 'AdSetSettingsForm',
  components: {
    BillingEventComboBox,
    TargetingComboBox,
    BudgetForm,
    ValueComboBox,
    RelativeDateComboBox
  },
  props: {
    value: { type: Object, required: true },
    event: { type: Object, required: false }
  },
  computed: {
    pixels() {
      return this.$store.getters.getCurrentUser.pixels
        ? this.$store.getters.getCurrentUser.pixels.map(({ id, name }) => ({ text: `${name} (ID: ${id})`, value: id }))
        : []
    },
    start() {
      if (!this.event) {
        return undefined
      }
      const { timeslots } = this.event.data
      const firstTimeslot = timeslots && timeslots[0]
      const start = firstTimeslot && firstTimeslot.start_date
      return start && start * 1000
    },
    end() {
      if (!this.event) {
        return undefined
      }
      const { timeslots } = this.event.data
      const lastTimeslot = timeslots && timeslots[timeslots.length - 1]
      const end = lastTimeslot && lastTimeslot.end_date
      return end && end * 1000
    }
  },
  data() {
    return {
      formData: this.value
    }
  },
  methods: {
    update(field, value) {
      this.formData[field] = value
      this.$emit('input', this.formData)
    }
  },
  mounted() {
    const pixel = this.pixels[0]
    this.update('pixel', pixel ? pixel.value : null)
  },
  watch: {
    value: function(oldValue, newValue) {
      this.formData = newValue
    }
  }
}
</script>

<template>
  <v-form>
    <billing-event-combo-box :value="formData.billingEvent" @input="update('billingEvent', $event)" />
    <targeting-combo-box :value="formData.targeting" @input="update('targeting', $event)" />
    <relative-date-combo-box
      :value="formData.start"
      @input="update('start', $event)"
      label="Start advertising"
      :start="start"
      :end="end"
    />
    <relative-date-combo-box
      :value="formData.end"
      @input="update('end', $event)"
      label="Stop advertising"
      :start="start"
      :end="end"
    />
    <budget-form :value="formData.budget" @input="update('budget', $event)" />
    <value-combo-box :value="formData.pixel" @input="update('pixel', $event)" :items="pixels" label="Facebook Pixel" />
  </v-form>
</template>
